import React , {useState , useEffect, useContext , } from 'react';
import Map, {NavigationControl , Marker , FullscreenControl , Popup} from 'react-map-gl';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { useGeolocated } from "react-geolocated";
import 'maplibre-gl/dist/maplibre-gl.css';
import Notification from '../components/Notification';
import SingleLocation from '../pages/SingleLocation';
import { getDocs , collection , db  } from '../firebase';
import { AppContext } from '../context/AppContext';
import Navbar from '../components/Navbar';


function MapPage() {

  const {retrive} = useContext(AppContext);

  const {view} = useContext(AppContext);

      const [ showLocation , setShowLocation ] = useState(false);
   

      const [ showEye , setShowEye ] = useState(false);
      const [ markersArray , setMarkersArray ] = useState([]);
      const [ marketingMarkersArray , setMarketingMarkersArray ] = useState([]);

      const {slideIndex} = useContext(AppContext);
     
      const [ indexSlideValue , setIndexSlideValue ] = slideIndex;

      const {location} = useContext(AppContext);

      const [ locationValue , setLocationValue ] = location;
  

      const [watch3d , setWatch3d] = view;

      const [retreivealMarker , setRetreivalMarker ] = retrive;

      const handleMarkerClick = ( name , description , category , photos , sections , stars , location , langitude , lattiude  , markerId) => {

        setShowEye(!showEye);
        setLocationValue(name);
        setIndexSlideValue(1);
        setRetreivalMarker({
          name,
          description,
          category,
          photos,
          sections,
          stars,
          location,
          langitude,
          lattiude,
          markerId
        });

        setShowLocation(!showLocation);

      }

          
  useEffect(  () => {

    const getMarkersData = async () => { 
      const querySnapshot = await getDocs(collection(db, "markers"));
      const usersDataArray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setMarkersArray(usersDataArray);
     
    }
    getMarkersData();
  } , []);

          
  useEffect(  () => {

    const getMarketingData = async () => { 
      const querySnapshot = await getDocs(collection(db, "marketing_markers "));
      const makeringData = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
   
      setMarketingMarkersArray(makeringData);
     
    }
    getMarketingData();
  } , []);






  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
  useGeolocated({
      positionOptions: {
          enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
  });


  return   <>

  <Navbar />
  
    {watch3d && (
      <div className="siaha_popup_div" >
  
  
      <div className="d-flex-f f-sp 3dmaps_div">
  
          <img src="/images/icons/left-nav.png" className='icon_mid' onClick={() => setWatch3d(!watch3d) } alt="" />
          <img src="/images/icons/logo.png" className='icon_mid' onClick={() => setWatch3d(!watch3d) } alt="" />
      </div>
         
     
   
  
      <iframe src={`https://maps.wrld3d.com/fullembed/?mapscene=${retreivealMarker.markerId}`} frameborder="0" style={{ border: 0,
       position:'relative',
       background: '#fff',
     
       padding: '0.1rem',
        left:0, 
        right:0,
         top:0, 
         bottom:0, 
         width:'100%', 
         zIndex: 15,
         height:'100%'
       }} allowfullscreen>
         
       </iframe>
       </div>
    )}
    
        <div className="App">
     
       <Notification showLocation={showLocation} setShowLocation={setShowLocation} />
  
       {showLocation && (
        <SingleLocation showActive={showLocation}  />
       )}
       
       
      <Map mapLib={maplibregl} 
        initialViewState={{
          longitude: 42.6666674,
            latitude: 17.333333,
          zoom: 7.2
        }}
        
        style={{width: "100%", height: " calc(100vh )"}}
        mapStyle="https://api.maptiler.com/maps/hybrid/style.json?key=zcK1SXnMzuUNV1RcYU2I"
      >
     <FullscreenControl />
  
  
        {markersArray && markersArray.map(( { id , icon , langitude , lattiude , name , description , category , photos , sections , stars , location , markerId } ) => (
          <Marker key={id}  longitude={langitude} latitude={lattiude} anchor="bottom" onClick={() => handleMarkerClick( name , description , category , photos , sections , stars , location , langitude , lattiude , markerId ) }  >
        <img className='icon_mid borderd_map_icon' src={icon} />
      </Marker>
        )) }
  
        {marketingMarkersArray && marketingMarkersArray.map(( { id , icon , langitude , lattiude , name , description , category , photos , sections , stars , location , markerId } ) => (
          <Marker key={id}  longitude={langitude} latitude={lattiude} anchor="bottom" onClick={() => handleMarkerClick( name , description , category , photos , sections , stars , location , langitude , lattiude , markerId ) }  >
        <img className='icon_mid borderd_map_icon' src={icon} />
      </Marker>
        )) }
  
          {showEye && (
            <Marker anchor="bottom" longitude={retreivealMarker.langitude} latitude={retreivealMarker.lattiude} onClick={() => setWatch3d(!watch3d) }  >
            <img className='icon_mid borderd_map_icon' src={'https://cdn-icons-png.flaticon.com/512/4955/4955419.png'} />
            </Marker>
          )}
  
  
        <NavigationControl position="top-left" />
      </Map>
    </div>
  
    </>



  
 

}

export default MapPage;